import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import CreateQtyLayer from "../../components/Settings/CreateQtyLayer";

const CreateQtyPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Create Quantity Settings" />
      <CreateQtyLayer />
    </MasterLayout>
  );
};

export default CreateQtyPage;
